module.exports = __webpack_public_path__ + "static/media/moreFeedbackBg.e76f6abf.png";